module.exports = __webpack_public_path__ + "static/media/tcw_screenshot.a971aa4b.jpeg";